// removed by extract-text-webpack-plugin
module.exports = {"user-post-demand":"user-post-demand"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-header/_PostDemand.scss
// module id = ./components/layouts/master/sub-header/_PostDemand.scss
// module chunks = 0